import QueryString from "query-string";
import {
  all,
  call,
  put,
  select,
  takeEvery,
  takeLatest,
} from "redux-saga/effects";
import api from "../../utils/api";
import { errorAlert } from "../Alerts/actions";
import {
  bulkPublishFailure,
  bulkPublishSuccess,
  fetchRotaFailure,
  fetchRotaStatFailure,
  fetchRotaStatSuccess,
  fetchRotaSuccess,
  fetchShiftsFailure,
  fetchShiftsSuccess,
  getShiftStatsFailure,
  getShiftStatsSuccess,
} from "./actions";
import {
  BULK_PUBLISH,
  FETCH_ROTA,
  FETCH_ROTA_STAT,
  FETCH_SHIFTS,
  GET_SHIFT_STATS,
} from "./constants";

export function* fetchRotaSaga({ payload, onSuccess }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload ? QueryString.stringify(payload) : "";
  try {
    const { data } = yield call(
      api(token).get,
      `/api/v3/employee-shift?${query}`,
      payload,
    );
    yield put(fetchRotaSuccess(data ?? []));
    typeof onSuccess === "function" && onSuccess(data ?? []);
  } catch (e) {
    yield put(fetchRotaFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching employee!"));
  }
}

export function* bulkPublishSaga({ payload, onPublishSuccess }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(
      api(token).post,
      `/api/shift-bulk-publish`,
      payload,
    );
    yield put(bulkPublishSuccess(data));
    typeof onPublishSuccess === "function" && onPublishSuccess();
  } catch (e) {
    yield put(bulkPublishFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while publishing"));
  }
}

export function* fetchRotaStatSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload ? QueryString.stringify(payload) : "";
  try {
    const { data } = yield call(
      api(token).get,
      `/api/unpublished-shift?${query}`,
      payload,
    );
    yield put(fetchRotaStatSuccess(data));
  } catch (e) {
    yield put(fetchRotaStatFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching employee!"));
  }
}
export function* fetchShiftsSaga({ payload, onSuccess }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload ? QueryString.stringify(payload) : "";
  try {
    const { data } = yield call(
      api(token).get,
      `/api/v3/roster-shift?${query}`,
      payload,
    );
    yield put(fetchShiftsSuccess(data ?? []));
    typeof onSuccess === "function" && onSuccess(data ?? []);
  } catch (e) {
    yield put(fetchShiftsFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching employee!"));
  }
}
export function* getShiftStatsSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload ? QueryString.stringify(payload) : "";
  try {
    const { data } = yield call(
      api(token).get,
      `/api/v3/roster-acknowledged-shift?${query}`,
      payload,
    );
    yield put(getShiftStatsSuccess(data));
  } catch (e) {
    yield put(getShiftStatsFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching shift stats!"));
  }
}

export function* fetchRotaFlow() {
  yield takeLatest(FETCH_ROTA, fetchRotaSaga);
}
export function* bulkPublishFlow() {
  yield takeEvery(BULK_PUBLISH, bulkPublishSaga);
}
export function* fetchRotaStatFlow() {
  yield takeEvery(FETCH_ROTA_STAT, fetchRotaStatSaga);
}
export function* fetchShiftsFlow() {
  yield takeLatest(FETCH_SHIFTS, fetchShiftsSaga);
}
export function* getShiftStatsFlow() {
  yield takeLatest(GET_SHIFT_STATS, getShiftStatsSaga);
}

export default function* RotaSaga() {
  yield all([
    fetchRotaFlow(),
    bulkPublishFlow(),
    fetchRotaStatFlow(),
    fetchShiftsFlow(),
    getShiftStatsFlow(),
  ]);
}
